interface FloatingBarFrameProps {
  isVisible: boolean;
  isScrolling: boolean;
  compactWidthClass: string;
  children: React.ReactNode;
}

const FloatingBarFrame = ({
  isVisible,
  isScrolling,
  compactWidthClass,
  children,
}: FloatingBarFrameProps) => {
  const wrapperStateClass = isScrolling
    ? `${compactWidthClass} scale-[0.96]`
    : 'w-[calc(100%-24px)] max-w-[760px] scale-100';

  return (
    <div
      className={`fixed bottom-5 left-1/2 z-50 origin-bottom -translate-x-1/2 transition-[width,transform] duration-300 ease-out ${wrapperStateClass} lg:w-max lg:scale-100`}
    >
      <div
        className={`origin-bottom transform-gpu transition-all duration-500 ease-out ${
          isVisible
            ? 'translate-y-0 opacity-100'
            : 'pointer-events-none translate-y-24 opacity-0'
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default FloatingBarFrame;
